import React, { useState } from 'react';

import { Modal } from '@wds/modal';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';

import { getCookie } from 'sma.common/utils';

import PropTypes from 'prop-types';
import STRINGS from '../../constants';

import RecoveryCodes from "../Authentication/components/RecoveryCodes";

const GenerateCodesModal = (props) => {
	const {
		open,
		setOpen,
	} = props;
	const [error, setError] = useState('');
	const [codes, setCodes] = useState([]);

	const handleOnClose = () => {
		setCodes([]);
		setOpen(false);
	};

	const fetchRecoveryCodes = async () => {
		try {
			const response = await fetch(reverse('api-internal-mfa-enroll'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRFToken': getCookie('csrftoken'),
				},
				body: JSON.stringify({ action: 'generate_recovery_codes' }),
			});
			return await response.json();
		} catch (error) {
			console.error(error);
			setError(STRINGS.unknownError);
		}
	}

	const handleGenerateNewCodes = async () => {
		const data = await fetchRecoveryCodes();
		if (data.success) {
			setCodes(data.recovery_codes);
		} else {
			setError(data.error || STRINGS.unknownError);
		}
	}
	return (
		<Box id='sma-deactivate-mfa-modal'>
			<Modal
				show={open}
				data-testid='mfa-deactivate-mfa-modal'
				onClose={handleOnClose}
			>
				<Modal.Header header={STRINGS.generateRecoveryCodes} />
				<Modal.Body>
					{codes.length > 0 ? (
						<RecoveryCodes
							codes={codes}
							error={error}
							showFinishButton={false}
						/>
					) : (
						<Typography>
							{STRINGS.generateNewCodesWarning}
						</Typography>
						)
					}
				</Modal.Body>
				<Modal.Footer align='right'>
					{codes.length > 0 ? (
						<Button
							onClick={() => handleOnClose()}
							id='sma-done-button'
							aria-label={STRINGS.done}
						>
							{STRINGS.done}
						</Button>
						) : (
							<>
								<Button onClick={() => handleOnClose()} id='sma-cancel-button' aria-label={STRINGS.cancel} variant='text'>
									{STRINGS.cancel}
								</Button>
								<Button onClick={() => handleGenerateNewCodes()} id='sma-generate-codes-button' aria-label={STRINGS.getNewCodes}>
									{STRINGS.getNewCodes}
								</Button>
							</>
						)
					}
				</Modal.Footer>
			</Modal>
		</Box>
	);
};

GenerateCodesModal.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
};

export default GenerateCodesModal;
